import { Button, Dropdown, Image } from 'antd'
import React from 'react'

export default function ActionButton({ menu }) {
  return (
    <Dropdown
      overlay={menu}
      placement='bottomRight'
      trigger={['click']}
      overlayClassName='lms-action-button'
    >
      <Button
        className='d-flex justify-content-center align-items-center'
        type='text'
        shape='circle'
      >
        <Image src='/image/ui-kit/action-icon.png' style={{ width: '32px' }} preview={false} />
      </Button>
    </Dropdown>
  )
}
